import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { linkRegel, type EbenenZustand } from '../bereichsEbene';
import { pfadVon } from '../../pages/einstellungen/EinstLink';
import { UEBER_ZIEL } from '../../pages/einstellungen/seiten';
import { einstellungenHilfeZiel, hilfeZielAusParameter, ohneHilfeParameter } from './hilfeLeiste';

// Alte Adressen führen auf die Seite (BAU-HILFE.md 1.2, PF-308-1). Beide Bausteine rendern nichts und ersetzen die Adresse;
// eingehängt werden sie erst in App.tsx (PF-308-2). Die Herkunft im Zustand folgt linkRegel, damit „Zurück zum Chat“ dorthin
// zurückführt, wo der Verweis stand.

/** ?hilfe=… auf jeder angemeldeten Seite: Herkunft ist dieselbe Ansicht ohne den Parameter (Weg „App → Bereich“). */
export function HilfeUmleitung() {
  const location = useLocation();
  const ziel = hilfeZielAusParameter(location.search);
  if (!ziel) return null;
  const regel = linkRegel({ ...location, search: ohneHilfeParameter(location.search) }, pfadVon(ziel));
  const zustand: EbenenZustand = regel.hintergrund ? { hintergrund: regel.hintergrund } : null;
  return <Navigate to={ziel} replace state={zustand} />;
}

/** /einstellungen/hilfe (Pop-up-Ebene, auch mit Anker #hilfe-<id>) → /hilfe/dokumente (Weg „Pop-up → Bereich“). */
export function EinstellungenHilfeUmleitung() {
  const location = useLocation();
  const ziel = einstellungenHilfeZiel(location.hash);
  const regel = linkRegel(location, pfadVon(ziel));
  const zustand: EbenenZustand = regel.hintergrund ? { hintergrund: regel.hintergrund } : null;
  return <Navigate to={ziel} replace state={zustand} />;
}

/** F-23 (Fehlersuche Nr. 8): /einstellungen/ueber (Pop-up-Ebene) → Abschnitt „Über … und Recht“ auf /hilfe/dokumente (Weg
 *  „Pop-up → Bereich“, Herkunft nach linkRegel wie oben). */
export function UeberUmleitung() {
  const location = useLocation();
  const regel = linkRegel(location, pfadVon(UEBER_ZIEL));
  const zustand: EbenenZustand = regel.hintergrund ? { hintergrund: regel.hintergrund } : null;
  return <Navigate to={UEBER_ZIEL} replace state={zustand} />;
}
